import { createReducer, on } from '@ngrx/store';
import { withEntityReducer } from '@aston/foundation';

import * as featureActions from './actions';
import { initialState, IAppState } from './state';


// declare our fully typed reducer
export const AppStoreReducer = createReducer(
	initialState,

	...withEntityReducer<IAppState>('user', featureActions.UserActions),
	...withEntityReducer<IAppState>('config', featureActions.ConfigActions),
	...withEntityReducer<IAppState>('factorConfig', featureActions.FactorConfigActions),
	...withEntityReducer<IAppState>('salesConditions', featureActions.salesConditionsActions),

	on(featureActions.StartInitializer, () => ({
		...initialState,
		app: {
			...initialState.app,
			isLoading: true
		}
	})),

	on(featureActions.FinishInitializer, state => ({
		...state,
		app: {
			...initialState.app,
			isLoading: false
		},
		isFinished: true
	})),

	on(featureActions.UpdateConfigSuccess, (state, action) => ({
		...state,
		config: {
			...state.config,
			entity: action.config
		}
	})),

	on(featureActions.LoadValidatorsRequest, state => ({
		...state,
		validatorsLoaded: false
	})),

	on(featureActions.LoadValidatorsSuccess, state => ({
		...state,
		validatorsLoaded: true
	})),

	on(featureActions.StartScrollToTop, state => ({
		...state,
		isScrolling: true
	})),

	on(featureActions.FinishScrollToTop, state => ({
		...state,
		isScrolling: false
	})),
);
